import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class DateValidator {

  /**
   * Checks if form control date is in the past
   * @param control
   */
  static inPast(control: FormControl): ValidationErrors | null {
    let today : Date = new Date();

    if (new Date(control.value) < today) {
      return { "inPast": true };
    }

    return null;
  }

  /**
   * Checks if the form control date is before the date provided as a parameter
   * @param inputDate
   */
  static beforeDate(inputDate: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let date : Date = new Date(inputDate);

      if (new Date(control.value) > date) {
        return { "afterDate": true };
      }

      return null;
    }
  }
}
